import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoConsultaLogLiberacaoSiad(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoconsultalogliberacaosiad/FIND_CONSULTALOGLIBERACAOSIAD':
      case '@operacaoconsultalogliberacaosiad/UPDATE_CONSULTALOGLIBERACAOSIAD':
      case '@operacaoconsultalogliberacaosiad/DELETE_CONSULTALOGLIBERACAOSIAD':
      case '@operacaoconsultalogliberacaosiad/STORE_CONSULTALOGLIBERACAOSIAD':
      case '@operacaoconsultalogliberacaosiad/CONSULTALOGLIBERACAOSIAD_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoconsultalogliberacaosiad/SUCCESS_REMOVE':
      case '@operacaoconsultalogliberacaosiad/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoconsultalogliberacaosiad/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoconsultalogliberacaosiad;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoconsultalogliberacaosiad/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoconsultalogliberacaosiad;
        break;
      }

      case '@operacaoconsultalogliberacaosiad/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
